import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';

const DeviceChoose = () => (
  <div>
    <h4 className="mb-3">Choose Device Type</h4>
    <Row>
      <Col md="4">
        <Link
          className="DeviceChoose__item"
          to="/account/devices/new?type=crm"
        >
          <div className="card text-center">
            <div className="card-body">
              <h4 className="card-title">Continuous</h4>
              <h6 className="card-subtitle text-muted">Radon Monitor</h6>
            </div>
          </div>
        </Link>
      </Col>

      <Col md="4">
        <Link
          className="DeviceChoose__item"
          to="/account/devices/new?type=electret"
        >
          <div className="card text-center">
            <div className="card-body">
              <h4 className="card-title">Electret</h4>
              <h6 className="card-subtitle text-muted">Voltage Reader</h6>
            </div>
          </div>
        </Link>
      </Col>
    </Row>
  </div>
);

export default DeviceChoose;



// WEBPACK FOOTER //
// ./src/features/device/DeviceChoose/DeviceChoose.js